import clsx from "clsx";

type Props = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export const CheckboxLabel = ({ label, value, onChange }: Props) => {
  return (
    <label className="checkbox inline-flex items-center space-x-3">
      <input type="checkbox" checked={value} className="peer hidden" onChange={() => onChange(!value)} />
      <span
        className={clsx(
          "relative",
          "block",
          "w-[18px]",
          "h-[18px]",
          "bg-white border-[1px] border-[#adb5bd]",
          "peer-checked:bg-[#dea221]",
          "peer-checked:border-1",
          "peer-checked:border-[#dea221]",
          "peer-checked:before:content-['']",
          "peer-checked:before:absolute",
          "peer-checked:before:top-[4px]",
          "peer-checked:before:left-[1px]",
          "peer-checked:before:block",
          "peer-checked:before:w-[14px]",
          "peer-checked:before:h-[7px]",
          "peer-checked:before:border-l-[2px]",
          "peer-checked:before:border-b-[2px]",
          "peer-checked:before:border-white",
          "peer-checked:before:-rotate-45"
        )}
      />
      <span className="whitespace-nowrap">{label}</span>
    </label>
  );
};
